import { Schema } from '../../Entities/Schema.entity';
import { createSchema } from '../../Utils/CreateSchema';

export const checkboxClickedSchema: Schema = {
  ...createSchema({
    version: '2-0-0',
    description: 'User interacted with a checkbox ',
    name: 'checkbox_clicked',
    properties: {
      listing_id: {
        type: 'string',
        description: 'the id of the listing',
      },
      user_id: {
        type: 'string',
        description: 'the id of the user',
      },
      checked: {
        type: 'boolean',
        description: 'checked',
      },
      name: {
        type: 'string',
        description: 'the name of the checkbox',
      },
      description: {
        type: 'string',
        description: 'the description of the checkbox',
      },
    },
  }),
};
